// eslint-disable-next-line import/prefer-default-export
export const bytesToMb = (kb: number): number | undefined => {
  if (kb === 0) return kb;
  if (!kb) return undefined;

  return kb / (1024 * 1024);
};